import Entity from './Entity';

import ActorCharacter from './ActorCharacter';
import Character from './Character';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class CharacterPattern implements Entity {
  constructor(
    public id: number,
    public character: Character,
    public actorCharacter: ActorCharacter,
    public actorCharacterId: number,
    public originalImageUrl: string,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
